module.exports = __webpack_public_path__ + "static/media/ikea.54ed7020.jpg";